<!-- 通话记录弹窗 -->
<template>
  <a-modal
    title="通话记录"
    :visible="visible"
    @cancel="closeModal"
    width="1100px"
    :footer="null"
    :destroyOnClose="true"
    :maskClosable="false"
    :bodyStyle="{ padding: '0 20px 20px' }"
  >
    <div class="TableCommunication">
      <div v-if="showSearch" class="search-container">
        <div class="search-item">
          <a-select
            v-model:value="queryParam.endStatus"
            placeholder="选择通话状态类型"
            style="width: 224px"
            size="large"
            allowClear
          >
            <a-select-option :value="item.value" v-for="item in statusOptions" :key="item.value">
              {{ item.lable }}
            </a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="dateList"
            :placeholder="['开始日期', '结束日期']"
            allowClear
            format="YYYY-MM-DD"
            :ranges="rangePresets"
            dropdownClassName="creatTime"
            :disabledDate="disabledDate"
          />
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="searchList">
            搜索
          </a-button>
        </div>
      </div>
      <a-table
        :loading="loading"
        :transformCellText="({ text }) => text ?? '--'"
        :bordered="true"
        :pagination="pagination"
        :dataSource="dataSource"
        :columns="col"
        :scroll="{ y: 300, x: '100%' }"
        @change="change"
        :rowKey="(_, index) => index"
      >
        <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
        <template #callerType="{ record }">
          <div class="service_person">
            <roles :solerType="record.callerType" />
            <span>{{ record.callerName }}</span>
          </div>
        </template>
        <!-- 接听人 callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
        <template #calleeName="{ record }">
          <div class="service_person">
            <roles :solerType="record.calleeType" />
            <span>{{ record.calleeName }}</span>
          </div>
        </template>
        <!-- 电话时长 -->
        <template #duration="{ record, index }">
          <template v-if="record.duration">
            <div v-if="record.isPlay">
              <audio :src="record.audioUrl" controls ref="audioRef"></audio>
            </div>
            <div v-else @click="onPlay(index)" class="call_duration">
              <img class="icon" :width="16" :height="16" :src="playIcon" />
              <span>{{ renderTime(record.duration) }}</span>
            </div>
          </template>
          <template v-else>--</template>
        </template>
        <template #operate="{ record }">
          <div v-if="record.buttonDisplay || record.readSummaryCheck">
            <a :style="{ marginRight: '10px' }" @click="openFullText(record)">通话全文</a>
            <!-- 只有本人可以编辑 编辑提交后全员可看 -->
            <a v-if="record.readSummaryCheck" @click="handleSummary(record)">查看小结</a>
            <!-- ai生成失败 -->
            <template v-if="record.chatSummaryStatus === 0">
              <a v-if="record.chatSummaryRetryCount < 2" @click="onCreateSummary(record)">
                AI重新生成小结
              </a>
              <a v-else v-show="record.writeSummaryCheck" @click="handleSummary(record)">
                填写小结
              </a>
            </template>
          </div>
          <span v-else>--</span>
        </template>
      </a-table>
      <a-modal
        title="沟通小结"
        :visible="summaryPanelVisible"
        @cancel="summaryPanelVisible = false"
        width="1059px"
        :footer="null"
        :destroyOnClose="true"
        :maskClosable="false"
        :bodyStyle="{
          padding: 0,
          paddingTop: '20px'
        }"
      >
        <summaryPannel
          :chatSummaryId="chatSummaryId"
          @closeSummaryModal="summaryPanelVisible = false"
          :origin="origin"
        />
      </a-modal>
      <FullText ref="FullTextRef" />
      <EditSummary ref="editSummaryRef" @changeTab="getData" />
    </div>
  </a-modal>
</template>

<script setup>
import playIcon from '@/assets/img/chat/playIcon.png'
import { getCdrList, getTccEndStatus } from '@/api/chat'
import { renderTime } from '@/utils'
import { ColCommunication as col } from '@/components/PatientFile/config'
import FullText from '@/components/FullText/index.vue'

import { ref, nextTick, reactive, defineExpose } from 'vue'
import { useSummary } from '@/hooks/useSummary'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import summaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'
import Roles from '@/components/Roles/index.vue'
import {
  rangePresets,
  disabledDate,
  formatDateForFilter
} from '@/components/PatientFile/ModalBody/tags/PlatformService/config'

const visible = ref(false)
const showSearch = ref(true)
// 患者信息（openModal 时传入）
const patientInfo = reactive({
  ucPatientId: null,
  prePatientId: null,
  patientType: 1
})
const dataSource = ref([])
const dateList = ref([])
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const statusOptions = ref([])
const queryParam = ref({
  endStatus: ''
})
const loading = ref(false)
const origin = ref(0)

const searchList = () => {
  getData()
}

async function getData() {
  const query = {
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize,
    ucPatientId: patientInfo.patientType ? patientInfo.ucPatientId : null,
    prePatientId: patientInfo.patientType === 0 ? patientInfo.prePatientId : null,
    cdrId: patientInfo.cdrId,
    ...queryParam.value
  }
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  query.startQueryTime = startTime
  query.endQueryTime = endTime
  loading.value = true
  dataSource.value = []
  getCdrList(query)
    .then(result => {
      const { list, totalCount } = result
      pagination.value.total = totalCount
      dataSource.value = list.map(v => {
        return {
          ...v,
          isPlay: false
        }
      })
      pagination.value.showTotal = () => `共${totalCount}条`
    })
    .catch(() => {})
    .finally(() => {
      loading.value = false
    })
}

const { editSummaryRef, chatSummaryId, summaryPanelVisible, handleSummary, onCreateSummary } =
  useSummary(getData)

const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getData()
}

const audioRef = ref(null)
// 播放录音
const onPlay = index => {
  dataSource.value.forEach((it, i) => {
    it.isPlay = index === i
  })
  nextTick(() => {
    audioRef.value.play()
  })
}

// 获取通话记录状态
const getStatusOptions = () => {
  getTccEndStatus().then(res => {
    statusOptions.value = res.map(it => {
      return { lable: it.value, value: it.code }
    })
    statusOptions.value.unshift({
      lable: '全部通话状态',
      value: ''
    })
  })
}

const FullTextRef = ref(null)
const openFullText = record => {
  const { cdrId } = record
  FullTextRef.value.openModal(cdrId)
}

// 打开弹窗
const openModal = data => {
  const {
    ucPatientId,
    prePatientId,
    patientType = 1,
    cdrId = null,
    showSearch: showSearchParam = true
  } = data
  patientInfo.ucPatientId = ucPatientId
  patientInfo.prePatientId = prePatientId
  patientInfo.patientType = patientType
  patientInfo.cdrId = cdrId
  showSearch.value = showSearchParam
  visible.value = true
  getStatusOptions()
  change()
}

// 关闭弹窗
const closeModal = () => {
  visible.value = false
  dataSource.value = []
  dateList.value = []
  pagination.value.current = 1
  pagination.value.pageSize = 10
  pagination.value.total = 0
}

defineExpose({ openModal, closeModal })
</script>

<style lang="scss" scoped>
.TableCommunication {
  .search-container {
    padding: 10px 0 0;
    background-color: #ffffff;
    .search-item {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 12px;
      .search-input {
        width: 224px;
      }
    }
  }
  .call_duration {
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      margin-right: 8px;
    }
  }
}
</style>
